export default __webpack_public_path__ + "static/media/filter_icon_parking.43e38145.svg";